export const navList = [
  {
    id: 1,
    path: "/",
    text: "Home",
  },
  {
    id: 2,
    path: "/about",
    text: "About",
  },
  {
    id: 3,
    path: "/services",
    text: "Services",
  },
  {
    id: 4,
    path: "/rooms",
    text: "Rooms",
  },
  // {
  //   id: 5,
  //   path: "/booking",
  //   text: "Booking",
  // },
  {
    id: 6,
    path: "/contact",
    text: "Contact",
  },
];

export const socialIcons = [
  {
    icon: <i className="fab fa-instagram"></i>,
    link: "https://www.instagram.com/hotel_bgm/",
  },
  {
    icon: <i className="fab fa-facebook-f"></i>,
    link: "https://www.facebook.com/profile.php?id=61566936007789",
  },
  // {
  //   icon: <i className="fab fa-twitter"></i>,
  // },
  // {
  //   icon: <i className="fab fa-linkedin-in"></i>,
  // },
  {
    icon: <i className="fab fa-youtube"></i>,
    link: "https://www.youtube.com/@HotelBGM",
  },
];
export const availRoomSample = [
  {
    roomType: "Normal Room",
    roomPrice: "999/-",
    description:
      "To see correct prices and occupancy information, please add the number of person and date.",
  },
  {
    roomType: "Standard Room",
    roomPrice: "1349/-",
    description:
      "To see correct prices and occupancy information, please add the number of person and date.",
  },
  {
    roomType: "Luxury Room",
    roomPrice: "1499/-",
    description:
      "To see correct prices and occupancy information, please add the number of person and date.",
  },
];
export const carouselData = [
  {
    img: "../assets/img/carousel-1.jpeg",
    title: "Discover A Brand Luxurious Hotel",
    subtitle: "luxury living",
    btn1: "Our Room",
    btn2: "Book Room",
  },
  {
    img: "../assets/img/carousel-2.jpeg",
    title: "**Unmarried Couple strictly Not Allowed",
    subtitle: "luxury living",
    btn1: "Our Room",
    btn2: "Book Room",
  },
];
export const about = [
  {
    icon: <i className="fa fa-hotel fa-2x text-warning mb-2"></i>,
    text: "Rooms",
    count: "30",
  },
  {
    icon: <i className="fa fa-users fa-2x text-warning mb-2"></i>,
    text: "Staffs",
    count: "50",
  },
  {
    icon: <i className="fa fa-users-cog fa-2x text-warning mb-2"></i>,
    text: "Clients",
    count: "100",
  },
];

export const services = [
  {
    icon: <i className="fa fa-hotel fa-2x text-warning"></i>,
    name: "Rooms & Appartment",
    discription:
      "Looking for the perfect room for your stay? At BGM Hotel & Restaurant, we offer a variety of elegantly designed rooms with reasonable price.",
  },
  {
    icon: <i className="fa fa-utensils fa-2x text-warning"></i>,
    name: "Food & Restaurant",
    discription:
      "Our on-site restaurant is a culinary destination in itself. Savor a menu crafted by our expert chefs, featuring local flavors and international favorites.",
  },

  {
    icon: <i className="fa fa-swimmer fa-2x text-warning"></i>,
    name: "Roof top Swimming Pool",
    discription:
      "Take your experience to new heights with a visit to our rooftop swimming pool. Offering panoramic views of Ghiloth.",
  },
  {
    icon: <i className="fa fa-glass-cheers fa-2x text-warning"></i>,
    name: "Event & Party",
    discription:
      "For Parties / events Booking Accepted also corporate monthly rooms available as per availability",
  },
];

export const footerItem = [
  {
    id: 1,
    header: "Company",
    UnitItem: [
      {
        name: "About Us",
        link: "about",
      },
      {
        name: "Rooms",
        link: "rooms",
      },
      {
        name: "Contact Us",
        link: "contact",
      },
      {
        name: "Privacy Policy",
        link: "policy",
      },
    ],
  },
  {
    id: 2,
    header: "Services",
    UnitItem: [
      {
        name: "Food & Restaurant",
      },

      {
        name: "Event & Party",
      },
    ],
  },
];

export const footerContact = [
  {
    icon: <i className="fa fa-map-marker-alt me-3"></i>,
    name: "BGM HOTEL RICCO COMERCIAL AREA, CG-70, Ghilot, Rajasthan 301705",
  },
  {
    icon: <i className="fa fa-phone-alt me-3"></i>,
    name: "+91 9873660008",
  },
  {
    icon: <i className="fa fa-envelope me-3"></i>,
    name: "bgmhotel6@gmail.com",
  },
];

export const contact = [
  {
    icon: <i className="fa fa-phone-alt text-warning me-2"></i>,
    title: "Booking ",
    email: "+91 9873660008",
  },
  {
    icon: <i className="fa fa-envelope-open text-warning me-2"></i>,
    title: "Reservation",
    email: "bgmhotel6@gmail.com",
  },
];

export const roomItems = [
  {
    img: "../assets/img/room-1.jpg",
    price: "$110/night",
    name: "Junior Suit",
    star: [
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
    ],
    description:
      "Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet lorem.",
    yellowbtn: "View Detail",
    darkbtn: "book now",
  },

  {
    img: "../assets/img/room-2.jpg",
    price: "$110/night",
    name: "Executive Suite",
    star: [
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
    ],
    description:
      "Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet lorem.",
    yellowbtn: "View Detail",
    darkbtn: "book now",
  },
  {
    img: "../assets/img/room-3.jpg",
    price: "$110/night",
    name: "Super Deluxe",
    star: [
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
      <small className="fa fa-star text-warning"></small>,
    ],
    description:
      "Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed diam stet diam sed stet lorem.",
    yellowbtn: "View Detail",
    darkbtn: "book now",
  },
];

export const facility = [
  {
    icon: <i className="fa fa-bed text-warning me-2"></i>,
    quantity: 3,
    facility: "bed",
  },
  {
    icon: <i className="fa fa-bath text-warning me-2"></i>,
    quantity: 2,
    facility: "bath",
  },
  {
    icon: <i className="fa fa-wifi text-warning me-2"></i>,
    facility: "Wifi",
  },
];
